import {Action} from '@ngrx/store';
import { Chat } from '../../../models/chat';

export class GetChatsSuccessAction implements Action {
  public static readonly type = 'GetChatsSuccessAction';

  constructor(public chats: Chat[]) {
  }

  public type = GetChatsSuccessAction.type;
}
